import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export const iconVariants = cva(['pointer-events-none'], {
  variants: {
    size: {
      xs: 'size-3',
      sm: 'size-4',
      md: 'size-5',
      lg: 'size-6',
      xl: 'size-8',
    },
  },
  defaultVariants: { size: 'md' },
})

export type IconSize = NonNullable<VariantProps<typeof iconVariants>['size']>

export const ICON_SIZE_REM: Record<IconSize, number> = { xs: 0.75, sm: 1, md: 1.25, lg: 1.5, xl: 2 }
